(function (Drupal, $) {
  Drupal.behaviors.lottie = {
    attach: function attach(context) {

      if ($(context).find(".field-item__field-menu .lottie-element").length) {
        let activeAnimation = null;

        $(context).find(".field-item__field-menu .lottie-element").each((index, item) => {
          const name = item.getAttribute('data-src');
          const animation = bodymovin.loadAnimation({
            container: item, // Required
            path: item.getAttribute('data-src'), // Required
            renderer: 'svg', // Required
            loop: false, // Optional
            autoplay: false, // Optional
            name: name, // Name for future reference. Optional.
          })

          if (!activeAnimation) {
            activeAnimation = animation;
          }

          $(item).closest('.field-item__field-menu').hover(function () {
            animation.setDirection(1);
            animation.play();
          }, function() {
            if (!$(item).closest('.field-item__field-menu').hasClass('active')) {
              animation.pause();
              animation.setDirection(-1);
              animation.play();
            }
          });

          $(item).closest('.field-item__field-menu').click(function () {
            if (!$(this).hasClass('active')) {
              if (activeAnimation) {
                activeAnimation.pause();
                activeAnimation.setDirection(-1);
                activeAnimation.play();
                activeAnimation = animation;
              }

              $(this).parent().find('.active').removeClass('active');
              $(this).addClass('active');
              const attr = $(this).attr('data-index');
              $('.menu-items').find('.active').removeClass('active');
              $('.menu-items [data-category=' + attr + ']').addClass('active');
            }
          })

        })
      }

    }
  }
})(Drupal, jQuery);
